var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPenGray(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 20H21.5",
    stroke: "#9CA3AF",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17 3.50023C17.3978 3.1024 17.9374 2.87891 18.5 2.87891C18.7786 2.87891 19.0544 2.93378 19.3118 3.04038C19.5692 3.14699 19.803 3.30324 20 3.50023C20.197 3.69721 20.3532 3.93106 20.4598 4.18843C20.5665 4.4458 20.6213 4.72165 20.6213 5.00023C20.6213 5.2788 20.5665 5.55465 20.4598 5.81202C20.3532 6.06939 20.197 6.30324 20 6.50023L7.5 19.0002L3.5 20.0002L4.5 16.0002L17 3.50023Z",
    stroke: "#9CA3AF",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPenGray);
export default __webpack_public_path__ + "static/media/penGray.697e01e470fb6aafb43ac90b5c9e80a5.svg";
export { ForwardRef as ReactComponent };